<div class="main-dialog">
  <div class="report-header" *ngIf="!filtersLoading">
    <app-project-stat-filter [columns]="columns" [statuses]="statuses" [installStatuses]="installStatuses" [users]="users"
                             (filterUpdated)="updateFilter($event)"></app-project-stat-filter>
  </div>

  <div class="total-overdue-block">
    <div class="pmnt est-pmnt">
				<span class="pmnt-span">
					${{totalInfo?.totalAmt | number:'1.2-2'}}
				</span>
      <span class="pmnt-title">
					Estimates
				</span>
    </div>
    <div class="pmnt inv-pmnt">
				<span class="pmnt-span">
					${{totalInfo?.invoicedBalance | number:'1.2-2'}}
				</span>
      <span class="pmnt-title">
					Invoiced
				</span>
    </div>
    <div class="pmnt pmnt-pmnt">
				<span class="pmnt-span">
					${{totalInfo?.paymentsReceived | number:'1.2-2'}}
				</span>
      <span class="pmnt-title">
					Payments
				</span>
    </div>
    <div class="pmnt bill-pmnt">
				<span class="pmnt-span">
					${{totalInfo?.unBilledAmount | number:'1.2-2'}}
				</span>
      <span class="pmnt-title">
					Unbilled
				</span>
    </div>
  </div>

  <div class="middle-content">
    <div class="header-order">
      <div class="date-block label-block">
        <div class="label-name" (click)="sortByLabel('created')" matRipple>DATE
          <i *ngIf="sortMap.get('created') === 1" class="pi pi-arrow-down"></i>
          <i *ngIf="sortMap.get('created') === 2" class="pi pi-arrow-up"></i>
        </div>
      </div>
      <div class="balance-block label-block">
        <div class="label-name" (click)="sortByLabel('list')" matRipple>COLUMN
          <i *ngIf="sortMap.get('list') === 1" class="pi pi-arrow-down"></i>
          <i *ngIf="sortMap.get('list') === 2" class="pi pi-arrow-up"></i>
        </div>
      </div>
      <div class="balance-block label-block">
        <div class="label-name" (click)="sortByLabel('manager')" matRipple>MANAGER
          <i *ngIf="sortMap.get('manager') === 1" class="pi pi-arrow-down"></i>
          <i *ngIf="sortMap.get('manager') === 2" class="pi pi-arrow-up"></i>
        </div>
      </div>
      <div class="balance-block label-block">
        <div class="label-name" (click)="sortByLabel('paymentStatus')" matRipple>STATUS
          <i *ngIf="sortMap.get('paymentStatus') === 1" class="pi pi-arrow-down"></i>
          <i *ngIf="sortMap.get('paymentStatus') === 2" class="pi pi-arrow-up"></i>
        </div>
      </div>
      <div class="balance-block label-block">
        <div class="label-name" (click)="sortByLabel('installPaymentStatus')" matRipple>Ins Status
          <i *ngIf="sortMap.get('installPaymentStatus') === 1" class="pi pi-arrow-down"></i>
          <i *ngIf="sortMap.get('installPaymentStatus') === 2" class="pi pi-arrow-up"></i>
        </div>
      </div>
      <div class="JOB-block label-block">
        <div class="label-name" (click)="sortByLabel('project')" matRipple>Job Name
          <i *ngIf="sortMap.get('project') === 1" class="pi pi-arrow-down"></i>
          <i *ngIf="sortMap.get('project') === 2" class="pi pi-arrow-up"></i>
        </div>
      </div>
    </div>

    <div class="transaction-lines">

      <div class="transaction-line"
           *ngFor="let reportLine of projReports; index as i; trackBy: trackEntityById">

        <div class="date-block label-block">
          <div class="label-name">{{reportLine.created | date: 'M/d/yy'}}</div>
        </div>
        <div class="type-block label-block">
          <div class="label-name">{{reportLine.list.name}}</div>
        </div>
        <div class="balance-block label-block">
          <div class="label-name">{{reportLine.manager.name}}</div>
        </div>
        <div class="balance-block label-block">
          <div class="label-name">{{reportLine.paymentStatus.name}}</div>
        </div>
        <div class="balance-block label-block">
          <div class="label-name">{{reportLine.installationPaymentStatus.name}}</div>
        </div>
        <div class="JOB-block label-block">
          <div class="label-name" (click)="openProject(reportLine.project?.id)">{{reportLine.project.name}}
          </div>
        </div>
      </div>

      <div class="psevdo-buttons">
        <div class="counter-block" *ngFor="let counter of counters">
          {{counter.columnName}}: {{counter.projectsCount}}
        </div>
      </div>

    </div>

    <div class="spinner-box" *ngIf="contentLoading">
      <mat-spinner class="spinner"></mat-spinner>
    </div>

  </div>

</div>
